import { Controller } from "@hotwired/stimulus"
import {
  addItemToRecentSearches,
  hide,
  show,
  openRecentSearch,
  fillRecentSearches,
} from "@/frontend/utils/searchHelpers"

const TOTAL_ELEMENTS_SIZE = 400
const FORM_ID = "search_form_mobile"

export default class extends Controller {
  static targets = [
    "filter",
    "detail",
    "input",
    "closeTextSearchBtn",
    "cleanInputBtn",
    "searchInputIcon",
    "footer",
    "recentSearches",
    "recentTiles",
  ]

  connect() {
    this.onWindowResize()
    this.openRecentSearch = openRecentSearch.bind(this, FORM_ID)
    this.fillRecentSearches = fillRecentSearches.bind(this)
  }

  onWindowResize() {
    this.filterTargets.forEach((el) => {
      el.style.height = `${window.innerHeight - TOTAL_ELEMENTS_SIZE}px`
    })
  }

  // Close other detail tags
  toggleDetails(event) {
    const currentDetails = event.currentTarget

    if (!currentDetails.open) return

    this.detailTargets.forEach((details) => {
      if (details !== currentDetails && details.open) {
        details.open = false
      }
    })
  }

  toggle(event) {
    const { open } = event.currentTarget
    this.collapseNavbar(open)
    Intercom?.("update", { hide_default_launcher: open })
  }

  collapseNavbar(open) {
    if (window.location.pathname !== "/") return

    const el = document.querySelector('[data-controller~="collapse-navbar"]')

    open ? hide([el]) : show([el])
  }

  cleanTextSearchInput() {
    this.inputTarget.value = ""
    hide([this.cleanInputBtnTarget])
  }

  handleTextSearchFocus() {
    this.fillRecentSearches()
    hide([...this.detailTargets, this.searchInputIconTarget, this.footerTarget])
    show([this.closeTextSearchBtnTarget, this.recentSearchesTarget])
    this.inputTarget.classList.add("pl-7")
  }

  backToGuidedSearch() {
    show([...this.detailTargets, this.searchInputIconTarget, this.footerTarget])
    this.inputTarget.classList.remove("pl-7")
    hide([this.closeTextSearchBtnTarget, this.recentSearchesTarget])
  }

  focusOnTextInput() {
    this.inputTarget.focus()
  }

  handleInputTyping() {
    this[this.inputTarget.value.length > 0 ? "show" : "hide"]([this.cleanInputBtnTarget])
  }

  closeModal() {
    this.element.closest("details").open = false
    this.backToGuidedSearch()
  }

  onFormSubmit() {
    addItemToRecentSearches(this.inputTarget.value)
    this.closeModal()
  }
}
